import { observer } from 'mobx-react-lite'
import { type StaticColumnDetails } from '@/features/documents/document-table-columns'
import { type DocumentManagementRowViewModel } from '@/features/documents/DocumentManagementRowViewModel'
import { DocumentManagementTableRow } from '@/features/documents/components/DocumentManagementTable/DocumentManagementTableRow'

export interface DocumentManagementTableRowContainerProps {
  vm: DocumentManagementRowViewModel
  columns: StaticColumnDetails[]
}

export const DocumentManagementTableRowContainer = observer(
  function DocumentManagementTableRowContainer({
    vm,
    columns,
  }: DocumentManagementTableRowContainerProps) {
    return (
      <DocumentManagementTableRow
        columnIds={columns.map((column) => column.id)}
        documentId={vm.document.id}
        title={vm.document.title}
        archived={vm.document.archived}
        workspaceName={vm.document.workspace.name}
        workspaceIcon={vm.document.workspace.branding.logos.icon}
        fileType={vm.document.fileType}
        dateModified={vm.document.dateModified}
        linkedJobs={vm.linkedJobs.map((job) => ({
          id: job.id,
          displayName: job.displayName,
        }))}
        isSelected={vm.isSelected}
        onToggleSelected={vm.toggleSelected}
        onDownload={vm.download}
        onShowDetails={vm.showDetails}
        onDelete={vm.delete}
      />
    )
  },
)
